import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, HelpCircle } from "lucide-react";
import { useApp, waLink, WA_MSG_EN, WA_MSG_AR } from "@/context/AppContext";
import { WIDTHS, PROFILES, RIMS, YEARS, BRANDS } from "@/i18n";

const sel = "w-full bg-[#0a0a0a] border border-[#27272a] text-white px-3 py-3 text-sm outline-none focus:border-[#EAB308] transition-colors";

const TyreSearch = ({ full = false }) => {
  const { tr, lang } = useApp();
  const s = tr.search;
  const nav = useNavigate();
  const [tab, setTab] = useState("size");
  const [dk, setDk] = useState(false);
  const [v, setV] = useState({ width: "", profile: "", rim: "", make: "", model: "", year: "", brand: "", qty: "" });
  const set = (k) => (e) => setV((p) => ({ ...p, [k]: e.target.value }));

  const go = (e) => {
    e.preventDefault();
    const size = v.width && v.rim ? `${v.width}/${v.profile || ""} ${v.rim}`.trim() : "";
    nav("/quotation", { state: { prefill: {
      tyre_size: size, vehicle_make: v.make, vehicle_model: v.model, vehicle_year: v.year,
      preferred_brand: v.brand, quantity: v.qty,
    }}});
  };

  return (
    <div className={`bg-[#121212] border border-[#27272a] ${full ? "" : "tyre-shadow"} p-6 md:p-8`} data-testid="tyre-search">
      <div className="flex items-center gap-1 mb-6 border-b border-[#27272a]">
        {[["size", s.bySize], ["vehicle", s.byVehicle]].map(([k, label]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`search-tab-${k}`}
            className={`px-5 py-3 text-sm font-bold uppercase tracking-wide transition-colors -mb-px border-b-2 ${
              tab === k ? "border-[#EAB308] text-[#EAB308]" : "border-transparent text-zinc-400 hover:text-white"}`}>
            {label}
          </button>
        ))}
      </div>

      <form onSubmit={go}>
        {tab === "size" ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div><label className="text-xs text-zinc-500 mb-1 block">{s.width}</label>
              <select className={sel} value={v.width} onChange={set("width")} data-testid="search-width"><option value="">{s.any}</option>{WIDTHS.map((w) => <option key={w}>{w}</option>)}</select></div>
            <div><label className="text-xs text-zinc-500 mb-1 block">{s.profile}</label>
              <select className={sel} value={v.profile} onChange={set("profile")} data-testid="search-profile"><option value="">{s.any}</option>{PROFILES.map((p) => <option key={p}>{p}</option>)}</select></div>
            <div><label className="text-xs text-zinc-500 mb-1 block">{s.rim}</label>
              <select className={sel} value={v.rim} onChange={set("rim")} data-testid="search-rim"><option value="">{s.any}</option>{RIMS.map((r) => <option key={r}>{r}</option>)}</select></div>
            <div><label className="text-xs text-zinc-500 mb-1 block">{s.qty}</label>
              <input type="number" min="1" className={sel} value={v.qty} onChange={set("qty")} placeholder="4" data-testid="search-qty" /></div>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div><label className="text-xs text-zinc-500 mb-1 block">{s.make}</label><input className={sel} value={v.make} onChange={set("make")} placeholder="Toyota" data-testid="search-make" /></div>
            <div><label className="text-xs text-zinc-500 mb-1 block">{s.model}</label><input className={sel} value={v.model} onChange={set("model")} placeholder="Land Cruiser" data-testid="search-model" /></div>
            <div><label className="text-xs text-zinc-500 mb-1 block">{s.year}</label>
              <select className={sel} value={v.year} onChange={set("year")} data-testid="search-year"><option value="">{s.any}</option>{YEARS.map((y) => <option key={y}>{y}</option>)}</select></div>
            <div><label className="text-xs text-zinc-500 mb-1 block">{s.brand}</label>
              <select className={sel} value={v.brand} onChange={set("brand")} data-testid="search-brand"><option value="">{s.any}</option>{BRANDS.map((b) => <option key={b}>{b}</option>)}</select></div>
          </div>
        )}

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mt-5">
          <p className="text-xs text-zinc-500">{s.example}</p>
          <button type="submit" data-testid="search-submit"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#EAB308] text-[#050505] font-bold px-8 py-3 uppercase tracking-wide hover:bg-[#ca8a04] transition-colors">
            <Search className="h-4 w-4" /> {s.submit}
          </button>
        </div>
      </form>

      <button onClick={() => setDk(!dk)} data-testid="dont-know-toggle"
        className="mt-4 inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-[#EAB308] transition-colors">
        <HelpCircle className="h-4 w-4" /> {s.dontKnow}
      </button>
      {dk && (
        <div className="mt-3 bg-[#0a0a0a] border border-[#27272a] p-4 text-sm text-zinc-400" data-testid="dont-know-info">
          {s.dontKnowText}
          <a href={waLink(lang === "ar" ? WA_MSG_AR : WA_MSG_EN)} target="_blank" rel="noopener noreferrer"
             className="block mt-2 text-[#25D366] font-semibold hover:underline">{tr.cta.whatsapp}</a>
        </div>
      )}
    </div>
  );
};

export default TyreSearch;
